// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1DYi4","navText":"Navbar_navText__3rgKz","navLogo":"Navbar_navLogo__s5cxL","imgLogo":"Navbar_imgLogo__1W8k_"};